import { Typography } from '@mui/material'
import React, { memo } from 'react'
import tw from 'twin.macro'
import { DriverPaymentMethod, PaymentMethodTypeEnum } from 'src/interfaces/paymentMethod'
import { PaymentData, getPaymentMethodDetails } from 'src/utils/paymentMethod'

interface ContractorPortalUsBankPaymentMethodDisplayProps {
  paymentMethod: DriverPaymentMethod | null
}

const getPaymentMethodLabel = (method: PaymentData): string => {
  return method?.type === PaymentMethodTypeEnum.Card ? 'Debit Card' : 'Bank Information'
}

const getUsBankPaymentData = (method: DriverPaymentMethod | null): PaymentData => {
  if (!method) {
    return null
  }

  const isCard = method.paymentMethodType === PaymentMethodTypeEnum.Card

  return isCard
    ? {
        type: method.paymentMethodType,
        lastDigits: method.cardNumberLast4 || '',
        expiration: method.cardExpiration || '',
      }
    : {
        type: method.paymentMethodType,
        accountLastDigits: method.bankAccountNumberLast4 || '',
        routingLastDigits: method.bankRoutingNumberLast4 || '',
      }
}

const ContractorPortalUsBankPaymentMethodDisplayComponent = ({
  paymentMethod,
}: ContractorPortalUsBankPaymentMethodDisplayProps) => {
  if (!paymentMethod) {
    return (
      <div css={tw`mt-6`}>
        <Typography css={tw`text-shades-400`}>You have no active payment method</Typography>
      </div>
    )
  }

  const paymentData = getUsBankPaymentData(paymentMethod)

  return (
    <>
      <div css={tw`mt-4`}>
        <Typography css={tw`text-shades-400 uppercase`} variant="overline">
          Current PAYMENT method
        </Typography>
      </div>
      <div css={tw`flex mt-2 items-center flex-row p-4 rounded-2xl bg-shades-0`}>
        <div>
          <Typography css={tw`text-shades-1000`} variant="h4">
            {getPaymentMethodLabel(paymentData)}
          </Typography>
          <Typography css={tw`mt-0.5 text-shades-400 capitalize`}>
            {getPaymentMethodDetails(paymentData)}
          </Typography>
        </div>
      </div>
    </>
  )
}

export const ContractorPortalUsBankPaymentMethodDisplay = memo(
  ContractorPortalUsBankPaymentMethodDisplayComponent,
)
